const localizationData = {
  highDemandMarkLabel: '04122017-152218-8439',
  prestigeMarkLabel: '26062017-084231-3737',
  bestValueMarkLabel: '24072017-154224-4042',
  unavailableForBookingOnline: '22072019-142052-0114',
  unavailableForYourSelection: '04032026-121916-0004', // Unavailable for your selection.
  openingSoon: '06052016-085644-6176', // Opening soon
  pleaseCall: '22072019-142459-6784',
  'toProceedWithTheBooking-regus': '05022025-153408-4555', // To proceed with the booking please login to MyRegus
  'toProceedWithTheBooking-spaces': '19032026-083437-0633', // To proceed with the booking please login to MySpaces
  'toProceedWithTheBooking-stopandwork': '', // To proceed with the booking please login to MyIwg
  textOnRoomImage: '10082020-095421-0211',
  login: '18012016-092142-4083',
  fromLabel: '02042019-131631-0127', // From
  seat: '27022017-133038-5392',
  seatsLabel: '14122016-161224-0424', // seats
  perSeatLabel: '00000000-000000-0000', // per seat
  locationNotAvailableForSelectedTime: '10082020-102247-0012', // This location is not available for the selected time.
  seeAvailability: '12122025-093921-1231',
  somethingWentWrong: '10082020-095421-0356', // Something went wrong. Please try again later.
  tryAgain: '24062020-121633-0115', // Try again
  perHour: '',
  perDay: ''
};

export default localizationData;
